import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function FilledLockKeyholeIcon({
  className,
  fill = IconColors.Grey,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        d="M17.0625 10.545V8.0625C17.0625 6.71984 16.5291 5.43217 15.5797 4.48277C14.6303 3.53337 13.3427 3 12 3C10.6573 3 9.36967 3.53337 8.42027 4.48277C7.47087 5.43217 6.9375 6.71984 6.9375 8.0625V10.545C6.3202 10.856 5.80089 11.3317 5.43692 11.9193C5.07295 12.507 4.87848 13.1838 4.875 13.875V17.25C4.875 18.2446 5.27009 19.1984 5.97335 19.9017C6.67661 20.6049 7.63044 21 8.625 21H15.375C16.3696 21 17.3234 20.6049 18.0267 19.9017C18.7299 19.1984 19.125 18.2446 19.125 17.25V13.875C19.1215 13.1838 18.9271 12.507 18.5631 11.9193C18.1991 11.3317 17.6798 10.856 17.0625 10.545ZM13.5 15.3375C13.5 15.6342 13.412 15.9242 13.2472 16.1709C13.0824 16.4175 12.8481 16.6098 12.574 16.7233C12.2999 16.8369 11.9983 16.8666 11.7074 16.8087C11.4164 16.7508 11.1491 16.6079 10.9393 16.3982C10.7296 16.1884 10.5867 15.9211 10.5288 15.6301C10.4709 15.3392 10.5006 15.0376 10.6142 14.7635C10.7277 14.4894 10.92 14.2551 11.1666 14.0903C11.4133 13.9255 11.7033 13.8375 12 13.8375C12.3978 13.8375 12.7794 13.9955 13.0607 14.2768C13.342 14.5581 13.5 14.9397 13.5 15.3375ZM12 4.875C12.8448 4.87698 13.6544 5.21344 14.2517 5.81079C14.8491 6.40813 15.1855 7.21773 15.1875 8.0625V9.75C15.1875 9.84946 15.148 9.94484 15.0777 10.0152C15.0073 10.0855 14.912 10.125 14.8125 10.125H9.1875C9.08804 10.125 8.99266 10.0855 8.92234 10.0152C8.85201 9.94484 8.8125 9.84946 8.8125 9.75V8.0625C8.81448 7.21773 9.15094 6.40813 9.74828 5.81079C10.3456 5.21344 11.1552 4.87698 12 4.875Z"
        fill={fill}
      />
    </SimpleIcon>
  );
}
